import { createClient } from '@supabase/supabase-js';
const supabaseUrl = process.env.VUE_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY || '';
if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Missing Supabase environment variables');
}
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
// Monitor Supabase connection errors and show helpful message
let errorShown = false;
// Detect DNS resolution errors (ERR_NAME_NOT_RESOLVED) for Supabase
const originalFetch = window.fetch;
window.fetch = function (...args) {
    return originalFetch.apply(this, args).catch((error) => {
        // Check if it's a Supabase DNS error
        if (!errorShown && args[0] && typeof args[0] === 'string' && args[0].includes('supabase.co')) {
            if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
                errorShown = true;
                console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #ff6b6b; font-weight: bold;');
                console.log('%c⚠️  SUPABASE PROJECT IS PAUSED  ⚠️', 'color: #ff6b6b; font-size: 16px; font-weight: bold;');
                console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #ff6b6b; font-weight: bold;');
                console.log('%cYour Supabase project is paused due to inactivity (7+ days).', 'color: #ffd93d; font-size: 14px;');
                console.log('');
                console.log('%cTO RESUME YOUR PROJECT:', 'color: #6bcf7f; font-size: 14px; font-weight: bold;');
                console.log('%c1. Go to: https://app.supabase.io/', 'color: #4ecdc4; font-size: 13px;');
                console.log('%c2. Find your paused project in the list', 'color: #4ecdc4; font-size: 13px;');
                console.log('%c3. Click the three-dot menu (⋮) → "Restore project"', 'color: #4ecdc4; font-size: 13px;');
                console.log('%c4. Wait 2-3 minutes for the project to restart', 'color: #4ecdc4; font-size: 13px;');
                console.log('%c5. Refresh this page', 'color: #4ecdc4; font-size: 13px;');
                console.log('');
                console.log('%cProject URL: ' + supabaseUrl, 'color: #95a5a6; font-size: 12px;');
                console.log('%cDirect Link: https://app.supabase.io/', 'color: #95a5a6; font-size: 12px;');
                console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #ff6b6b; font-weight: bold;');
            }
        }
        throw error;
    });
};
